export const apiConsts = {
  Page: 0,
  PageSize: 10,
  PageSizeForSearch: 100,
  Max: 2147483647,
}
